// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"07d5a830","335":"0c2bdba4","963":"894bdb4b"}[chunkId] + ".chunk.js";
};